import {
	formatRangeLabel,
	presetToRange,
	type DateRangePreset,
} from '@/pages/dashboard/utils/dateRangeUtils'
import moment from 'moment'
import { useCallback, useMemo, useState } from 'react'

export function useDateRangeFilter(defaultPreset: Exclude<DateRangePreset, 'custom'> = '30') {
	const defaultRange = useMemo(() => presetToRange(defaultPreset), [defaultPreset])
	const [preset, setPreset] = useState<DateRangePreset>(defaultPreset)
	const [dateFrom, setDateFrom] = useState(defaultRange.dateFrom)
	const [dateTo, setDateTo] = useState(defaultRange.dateTo)
	const [appliedRange, setAppliedRange] = useState(defaultRange)

	const onApplyRange = useCallback(() => {
		if (!dateFrom || !dateTo) return
		if (moment(dateFrom).isAfter(dateTo)) return
		setPreset('custom')
		setAppliedRange({ dateFrom, dateTo })
	}, [dateFrom, dateTo])

	const onPresetClick = useCallback((id: Exclude<DateRangePreset, 'custom'>) => {
		const range = presetToRange(id)
		setPreset(id)
		setDateFrom(range.dateFrom)
		setDateTo(range.dateTo)
		setAppliedRange(range)
	}, [])

	const rangeLabel = formatRangeLabel(appliedRange.dateFrom, appliedRange.dateTo)

	return {
		preset,
		dateFrom,
		dateTo,
		appliedRange,
		rangeLabel,
		setDateFrom,
		setDateTo,
		onApplyRange,
		onPresetClick,
	}
}
